import _ from 'underscore';

import BaseView from '../../../base-view';
import Collection from '../collection';
import ItemView from '../item/view';

export default BaseView.extend({
	className: 'suggest__list is-hidden',
	tagName: 'ul',

	labels: {
		suggestNoResult: 'Nothing found'
	},

	initialize: function(options) {
		// set labels
		this.labels =  _.extend(this.labels, window.labels || {});

		this.collection = this.collection || new Collection();

		// listeners
		this.listenTo(this.collection, 'reset', this.onCollectionReset);
	},

	// collection reset handler: rerender view
	onCollectionReset: function(collection, options) {
		// Trigger 'remove' event on previous models, so that the old views can be removed and don't get stale
		options.previousModels.forEach(function(model) {
			model.trigger('remove');
		});

		this.render();
	},

	// show the list
	show: function() {
		this.el.classList.remove('is-hidden');
	},

	// hide the list
	hide: function() {
		this.el.classList.add('is-hidden');
	},

	// returns whether the list is visible or not (bool)
	isVisible: function() {
		return this.el.classList.contains('is-hidden');
	},

	// compose the list with items, or show empty result
	composeList: function() {
		// empty the list
		this.el.innerHTML = '';

		if (this.collection.length) {
			// add items
			this.renderItems();
		} else {
			// show empty result
			this.renderEmpty();
		}
	},

	// add suggest items to the list
	renderItems: function() {
		// create fragment containing all list items
		var fragment = document.createDocumentFragment(),
			listItem;

		this.collection.forEach(function(model) {
			listItem = new ItemView({ model: model }).render();
			fragment.appendChild(listItem.el);
		}, this);

		// append all list items at once
		this.el.appendChild(fragment);
	},

	renderEmpty: function() {
		this.el.innerHTML = '<li class="suggest__item is-empty">' + this.labels.suggestNoResult + '</li>';
		return this;
	},

	// render the list
	render: function() {
		this.composeList();
		return this;
	}
});
